'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload from "./presto.types$-Two-Factor-Auth-Email-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthEmailPayload$() {
}
export { $c_Lpresto_types$TwoFactorAuthEmailPayload$ as $c_Lpresto_types$TwoFactorAuthEmailPayload$ };
$p = $c_Lpresto_types$TwoFactorAuthEmailPayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthEmailPayload$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthEmailPayload$() {
}
export { $h_Lpresto_types$TwoFactorAuthEmailPayload$ as $h_Lpresto_types$TwoFactorAuthEmailPayload$ };
$h_Lpresto_types$TwoFactorAuthEmailPayload$.prototype = $p;
$p.l = (function() {
  return "TwoFactorAuthEmailPayload";
});
$p.cHC = (function(x$0) {
  return new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload.$c_Lpresto_types$TwoFactorAuthEmailPayload(x$0.j(0));
});
var $d_Lpresto_types$TwoFactorAuthEmailPayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthEmailPayload$, "presto.types$TwoFactorAuthEmailPayload$", ({
  a2n: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$TwoFactorAuthEmailPayload$ as $d_Lpresto_types$TwoFactorAuthEmailPayload$ };
var $n_Lpresto_types$TwoFactorAuthEmailPayload$;
function $m_Lpresto_types$TwoFactorAuthEmailPayload$() {
  if ((!$n_Lpresto_types$TwoFactorAuthEmailPayload$)) {
    $n_Lpresto_types$TwoFactorAuthEmailPayload$ = new $c_Lpresto_types$TwoFactorAuthEmailPayload$();
  }
  return $n_Lpresto_types$TwoFactorAuthEmailPayload$;
}
export { $m_Lpresto_types$TwoFactorAuthEmailPayload$ as $m_Lpresto_types$TwoFactorAuthEmailPayload$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Email-Payload$.js.map
